<section class="player-section">
    <header class="sticky-header">
        <button mat-icon-button (click)="close()" class="close-button"><mat-icon>close</mat-icon></button>
        <div class="player-detail">
            <app-image
                [player]="player"
                [display_flag]="true"
                [width]="'120px'"
                [height]="'120px'"
                style="display: block"
                [app_country_flag_width]="'2rem'"
                [country_flag_left]="'6rem'"
                [country_flag_top]="'0.6rem'"
            ></app-image>

            <div class="player-meta">
                <div class="player-name">{{ player.first_name }} {{ player.last_name }}</div>

                <div class="action-row">
                    @if (following) {
                        <button mat-stroked-button class="follow-btn" (click)="handleFollow($event)">Unfollow</button>
                    } @else {
                        <button mat-stroked-button class="follow-btn" (click)="handleFollow($event)">
                            {{ appStringAPI.getAppString('tennis.players.follow') }}
                        </button>
                    }

                    @if (player.merchandise_url) {
                        <button mat-stroked-button class="gear-btn" (click)="openPlayerGear(player.merchandise_url)">
                            {{ appStringAPI.getAppString('golf.player.merchandise.title') }}
                        </button>
                    }
                </div>
            </div>
        </div>
    </header>

    <app-player-detail [player]="player"></app-player-detail>
</section>
